import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای توقفات تولید (Downtimes)

بخش مدیریت توقفات جهت مانیتورینگ آنلاین وضعیت ماشین‌آلات و ثبت دقیق دلایل توقف خط تولید ایجاد شده است. با استفاده از این اطلاعات، سیستم می‌تواند شاخص OEE را به صورت دقیق محاسبه کند.

## ثبت توقف جدید

<Alert variant="warning">
برای ثبت توقف حتماً باید یک ایستگاه کاری در داشبورد Shopfloor انتخاب شده باشد. در صورتی که دستگاه هم‌اکنون متوقف است، نمی‌توانید توقف جدیدی ثبت کنید تا زمانی که توقف قبلی به پایان برسد.
</Alert>

۱. از منوی کشویی، علت دقیق توقف را انتخاب کنید (مثلاً "خرابی مکانیکی" یا "کمبود مواد").
۲. در صورت نیاز، توضیحات تکمیلی (نظیر قطعه معیوب یا نام تکنسین تعمیرات) را بنویسید.
۳. روی دکمه ثبت توقف کلیک کنید. سیستم زمان دقیق کلیک شما را به عنوان آغاز توقف در نظر می‌گیرد.

## پایان توقف

وقتی دستگاه مجدداً آماده به کار شد، روی دکمه قرمزرنگ **پایان توقف** کلیک کنید. سیستم بلافاصله زمان را ثبت کرده و مدت توقف (به دقیقه) محاسبه می‌شود.

export default Layout;
